export const TotalInvestmentChart = {
    series: [{
        name: "Peter",
        data: [0, 25000, 17000, 38000, 20000, 30000],
        color: "var(--theme-color3)",
    },],
    chart: {
        height: 300,
        type: "line",
        toolbar: {
            show: false,
        },
        zoom: {
            enabled: false,
        },
        animations: {
            enabled: false,
        },
    },
    stroke: {
        width: [5, 5, 4],
        curve: "straight",
    },
    labels: [2016, 2017, 2018, 2019, 2020, 2021],

    xaxis: {},
};